/*
  Boboné wishlist — no-app, browser-based "Favoritos".
  Saved products live in localStorage (per browser/device, no account needed).
  - Heart toggles on product cards store the product handle.
  - The header heart shows a live count and links to /pages/favoritos.
  - The Favoritos page fetches each saved product (/products/<handle>.js) and
    renders Boboné product cards from them.
*/
(function () {
  var KEY = 'bobone:wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function has(handle) { return read().indexOf(handle) !== -1; }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) { list.push(handle); } else { list.splice(i, 1); }
    write(list);
    return i === -1; // true when now saved
  }
  function esc(s) {
    return (window.CSS && CSS.escape) ? CSS.escape(s) : String(s).replace(/"/g, '\\"');
  }

  function updateCount() {
    var n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function syncButton(btn) {
    var saved = has(btn.getAttribute('data-wishlist-handle'));
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    btn.classList.toggle('is-saved', saved);
    var label = saved ? 'Quitar de favoritos' : 'Guardar en favoritos';
    btn.setAttribute('aria-label', label);
    btn.setAttribute('title', label);
  }

  function activate(e, btn) {
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-wishlist-handle');
    var nowSaved = toggle(handle);
    document.querySelectorAll('[data-wishlist-handle="' + esc(handle) + '"]').forEach(syncButton);
    updateCount();

    // On the Favoritos page, un-saving removes the card from the grid.
    if (!nowSaved) {
      var grid = document.querySelector('[data-wishlist-grid]');
      if (grid) {
        var card = btn.closest('.bobone-product-card');
        if (card && grid.contains(card)) {
          card.remove();
          if (!grid.querySelector('.bobone-product-card')) {
            var empty = document.querySelector('[data-wishlist-empty]');
            if (empty) { empty.hidden = false; }
          }
        }
      }
    }
  }

  function wireButton(btn) {
    if (btn.dataset.wishlistWired) { return; }
    btn.dataset.wishlistWired = '1';
    syncButton(btn);
    btn.addEventListener('click', function (e) { activate(e, btn); });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { activate(e, btn); }
    });
  }

  function wireAll(root) {
    (root || document).querySelectorAll('[data-wishlist-toggle]').forEach(wireButton);
  }

  /* ---------- Favoritos page ---------- */
  function money(cents) {
    return '$' + (cents / 100).toLocaleString('es-MX', { maximumFractionDigits: 0 });
  }
  function sized(url, w) {
    if (!url) { return ''; }
    var abs = url.indexOf('//') === 0 ? 'https:' + url : url;
    return abs + (abs.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function esc_html(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function cardHTML(p) {
    var title = esc_html(p.title);
    var img = p.featured_image
      ? '<img class="bobone-product-card__image" src="' + esc_html(sized(p.featured_image, 800)) + '" alt="' + title + '" loading="lazy">'
      : '<span class="bobone-product-card__placeholder"></span>';
    // Kits are gift-set prices: quiet "por separado" line, never a struck price [CB 2026-10-08]
    var isKit = (p.tags || []).indexOf('kit') > -1;
    var hasCompare = p.compare_at_price && p.compare_at_price > p.price;
    var was = (hasCompare && !isKit)
      ? '<span class="bobone-product-card__price-was">' + money(p.compare_at_price) + '</span>' : '';
    var separado = (hasCompare && isKit)
      ? '<span class="bobone-product-card__separado">por separado ' + money(p.compare_at_price) + '</span>' : '';
    var type = p.type ? '<span class="bobone-product-card__category">' + esc_html(p.type) + '</span>' : '';
    var heart = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 14c1.4-1.4 3-3.4 3-5.6A4.4 4.4 0 0 0 12 5.6 4.4 4.4 0 0 0 2 8.4c0 2.2 1.6 4.2 3 5.6l7 7Z"></path></svg>';
    return '' +
      '<a href="' + esc_html(p.url) + '" class="bobone-product-card" data-bobone-card>' +
        '<span class="bobone-product-card__frame">' + img +
          '<span class="bobone-wishlist-btn is-saved" role="button" tabindex="0" data-wishlist-toggle data-wishlist-handle="' +
            esc_html(p.handle) + '" aria-pressed="true" aria-label="Quitar de favoritos">' + heart + '</span>' +
        '</span>' +
        '<span class="bobone-product-card__meta"><span class="bobone-product-card__text">' + type +
          '<span class="bobone-product-card__name">' + title + '</span>' +
          '<span class="bobone-product-card__price"><span class="bobone-product-card__price-now">' + money(p.price) + '</span>' + was + '</span>' + separado +
        '</span></span>' +
      '</a>';
  }

  function renderPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) { return; }
    var empty = document.querySelector('[data-wishlist-empty]');
    var handles = read();
    if (!handles.length) {
      grid.innerHTML = '';
      if (empty) { empty.hidden = false; }
      return;
    }
    if (empty) { empty.hidden = true; }
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var live = products.filter(Boolean);
      // Prune handles that no longer resolve (deleted/unpublished products).
      if (live.length !== handles.length) {
        write(live.map(function (p) { return p.handle; }));
      }
      if (!live.length) {
        grid.innerHTML = '';
        if (empty) { empty.hidden = false; }
        updateCount();
        return;
      }
      grid.innerHTML = live.map(cardHTML).join('');
      wireAll(grid);
      updateCount();
    });
  }

  function init() {
    wireAll(document);
    updateCount();
    renderPage();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Theme editor + AJAX-loaded sections (filtered collections, pagination).
  document.addEventListener('shopify:section:load', function (e) { wireAll(e.target); updateCount(); });
  // Restore state when returning via back/forward cache.
  window.addEventListener('pageshow', updateCount);
})();
